import React from 'react';
import { withStyles, Grid, withRouter } from '../../../material-ui';

import Apis from '../../../network/Apis';
import RaceEvent from './RaceEvent';
import RaceEventHuanRen from './RaceEventHuanRen';
import RaceEventEnd from './RaceEventEnd';
import DataUtils from '../../../model/DataUtils';

class MovieStateFootBallStatistics extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            value: 1,
            incidents: [],
        };
        console.log('MovieStateBasketStatistics', props);
    }

    componentDidMount() {
        this.getBasketballRealtimeData();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getBasketballRealtimeData = async () => {
        let { matchId, matchType } = this.props.match.params;
        const { data } = this.props;

        if (matchType == 0) {
            matchType = data.match_type;
        }
        if (matchId == 0) {
            matchId = data.match_id;
        }

        let result = await Apis.encryptionDetailLive(matchType, matchId);
        console.log('MovieStateBasketStatistics', result);
        if (result.code == 200) {
            let incidents = [];
            if (result.data.incidents) {
                incidents = result.data.incidents.reverse();
            }
            this.setState({ incidents: incidents });
        }
    }

    renderByType(item, type, i) {
        if (type == 1 || type == 2 || type == 3 || type == 4 || type == 15 || type == 16 || type == 17) {
            return (
                <RaceEvent
                    key={i}
                    data={item}
                    type={item.type}
                    stitle={item.position == 1 ? item.player_name : ''}
                    playernumber={item.time}
                    etitle={item.position == 2 ? item.player_name : ''}
                    position={item.position}
                />
            );
        } else if (type == 9) {
            return (
                <RaceEventHuanRen
                    key={i}
                    data={item}
                    time={item.time}
                    type={item.type}
                    in_player_name={item.in_player_name}
                    out_player_name={item.out_player_name}
                    position={item.position}
                />
            );
        }

        return (
            <RaceEventEnd
                key={i}
                data={item}
                type={DataUtils.getType(item.type)}
            />
        );
    }

    render() {
        const { classes } = this.props;
        const { incidents } = this.state;
        return (
            <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.root}>
                {
                    incidents.map((item, i) => (
                        this.renderByType(item, item.type, i)
                    ))
                }
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        borderRadius: 10,
        backgroundColor: '#FFF'
    },


}))(MovieStateFootBallStatistics));